import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vehicle-card d-flex flex-column align-items-center justify-content-between" }
const _hoisted_2 = { class: "vehicle-card__header d-flex justify-content-end w-100" }
const _hoisted_3 = { class: "vehicle-card__body d-flex flex-column align-items-center" }
const _hoisted_4 = { class: "vehicle-card__footer" }
const _hoisted_5 = { class: "vehicle-card__footer__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VehicleCardFreeItemWrapperComponent = _resolveComponent("VehicleCardFreeItemWrapperComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<button class=\"vehicle-card__header__info-button d-flex align-items-center d-none\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path id=\"stroke1\" d=\"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z\" stroke=\"#0029FF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"stroke2\" d=\"M12 16V12\" stroke=\"#0029FF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"stroke3\" d=\"M12 8H12.01\" stroke=\"#0029FF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></button>", 1)),
      _renderSlot(_ctx.$slots, "seats")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "image")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "maker_model"),
        _renderSlot(_ctx.$slots, "price"),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hr-line" }, null, -1)),
        _createVNode(_component_VehicleCardFreeItemWrapperComponent)
      ])
    ])
  ]))
}